import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import AthletesAwaitingModeration from "@images/payment/athletesAwaitingModeration.svg"
import { word } from "@modules/core/utils/i18n"
import { useProgramSidebar } from "@modules/programs/hooks/useProgramSidebar"
import { Text } from "@/components/ui/baseUi/text"

type ProgramSasWarningProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramSasWarning({ programId, className, ...props }: ProgramSasWarningProps) {
  const { navigateToProgramSasPaymentChoices } = useProgramSidebar()

  const onValidate = () => {
    navigateToProgramSasPaymentChoices(programId)
  }

  return (
    <div className={cn("flex grow flex-col gap-4 px-5 pt-18 pb-6", className)} {...props}>
      <div className="flex flex-col gap-1">
        <Text fontStyle="TL">{word("program.price.membershipPrice")}</Text>
        <Text fontStyle="BS">{word("program.price.membershipPriceDescription")}</Text>
      </div>

      <div className="my-4 flex flex-col gap-4 px-22">
        <Text fontStyle="TL" className="text-center">
          {word("program.sasWarning.title")}
        </Text>
        <Text fontStyle="BS" className="text-center">
          {word("program.sasWarning.description")}
        </Text>
      </div>

      <div className="card flex items-center justify-center p-7">
        <img src={AthletesAwaitingModeration} alt={word("program.sasWarning.title")} />
      </div>

      <Button variant="primary" size="lg" className="w-full" onClick={onValidate}>
        {word("program.sasWarning.button")}
      </Button>
    </div>
  )
}
